module.exports = __webpack_public_path__ + "static/media/nike-cant-stop-that-dance.ece52675.jpg";